/*
 * CustomLoadQueue
 */

createjs.RequestUtils.getTypeByExtension = function(extension) {
    if (extension == null) {
        return createjs.Types.TEXT;
    }

    switch (extension.toLowerCase()) {
        case "jpeg":
        case "jpg":
        case "gif":
        case "png":
        case "webp":
        case "bmp":
            return createjs.Types.IMAGE;
        case "ogg":
        case "mp3":
        case "webm":
        case "aac":
            return createjs.Types.BINARY;
        case "mp4":
        case "webm":
        case "ts":
            return createjs.Types.VIDEO;
        case "json":
            return createjs.Types.JSON;
        case "xml":
            return createjs.Types.XML;
        case "css":
            return createjs.Types.CSS;
        case "js":
            return createjs.Types.JAVASCRIPT;
        case 'svg':
            return createjs.Types.SVG;
        default:
            return createjs.Types.TEXT;
    }
};

(function() {
    function CustomLoadQueue(preferXHR, basePath, crossOrigin) {
        this.LoadQueue_constructor(preferXHR, basePath, crossOrigin);

        this.scriptsPreferXHR = true;
        this.injectScriptsToHead = true;
        this.deferScripts = false;
        this.asyncScripts = false;

        this._canceledLoads = [];
        this._duplicates = [];
        this._completedScripts = [];
    };

    var p = createjs.extend(CustomLoadQueue, createjs.LoadQueue);
    var s = CustomLoadQueue;

    // custom public methods
    p.getBusyItems = function(itemsToIgnoreById) {
        var busyItems = [];

        for (var id in this._loadItemsById) {
            if (itemsToIgnoreById != null && itemsToIgnoreById.length > 0) {
                var ignore = createjs.indexOf(itemsToIgnoreById, id) !== -1;
                if (ignore) continue;
            }

            var item = this._loadItemsById[id];
            var hasResult = this.getResult(id) != null;
            if (hasResult) continue;

            // remove addition of basePath inside the item's src if required
            var regex = new RegExp(`^${this._basePath}`);
            var src = item.src;
            if (regex.test(src)) {
                src = src.replace(this._basePath, "");
            }
            busyItems.push({
                id: item.id,
                src: src
            });
        }

        return busyItems;
    };

    p.getBusyItemsById = function(itemsToIgnoreById) {
        var busyItems = this.getBusyItems(itemsToIgnoreById);

        return Array.from(busyItems, item => item.id);
    };

    p.reprioritizeLoad = function(priorityItems) {
        this._duplicates = this._getDuplicateLoadItems(priorityItems);
        this._canceledLoads = this.getBusyItems(this._duplicates);

        this.remove(Array.from(this._canceledLoads, item => item.id));

        var itemsForNextLoad = this._getItemsForReprioritization(priorityItems);
        this.loadManifest(itemsForNextLoad);
    };

    p.reprioritizeQueue = function(priorityItems) {
        this.setPaused(true);

        const priorityItemsInQueue = this._loadQueue.filter(
            function getPriorityItemsInQueue(itemInQueue) {
                for (let priorityItem of priorityItems) {
                    if (priorityItem.id === itemInQueue.getItem().id) return true;
                }
                return false;
            }
        );

        if (priorityItemsInQueue.length > 0) {
            for (let priorityItem of priorityItemsInQueue) {
                this._loadQueue.splice(this._loadQueue.indexOf(priorityItem), 1);
            }
            this._loadQueue.unshift(...priorityItemsInQueue);
        };

        this.setPaused(false);
    };

    p.initializeConfig = function(value) {
        this.maintainScriptOrder = value.maintainScriptOrder;
        this.scriptsPreferXHR = window.scriptsPreferXHR = value.scriptsPreferXHR;
        this.injectScriptsToHead = window.injectScriptsToHead = value.injectScriptsToHead;
        this.deferScripts = window.deferScripts = value.deferScripts;
        this.asyncScripts = window.asyncScripts = value.asyncScripts;
    };

    // override public methods
    p.remove = function(idsOrUrls, autoLoadOnItemsRemoved = false) {
        var args = null;

        if (!idsOrUrls) return;

        if (Array.isArray(idsOrUrls)) {
            args = idsOrUrls;
        } else {
            args = [idsOrUrls];
        }

        var itemsWereRemoved = false;

        while (args.length) {
            var item = args.pop();

            // Item has already loaded - skip
            if (this.getResult(item)) continue;

            // Remove from the main load Queue (item's that haven't started yet)
            for (var i = this._loadQueue.length - 1; i >= 0; i--) {
                loadItem = this._loadQueue[i].getItem();
                if (loadItem.id == item || loadItem.src == item) {
                    this._numItems--;
                    this._loadQueue.splice(i, 1)[0].cancel();
                    break;
                }
            }

            // Remove items that are currently loading
            for (var i = this._currentLoads.length - 1; i >= 0; i--) {
                var loadItem = this._currentLoads[i].getItem();
                if (loadItem.id == item || loadItem.src == item) {
                    this._numItems--;
                    this._currentLoads.splice(i, 1)[0].cancel();
                    itemsWereRemoved = true;
                    break;
                }
            }
        }

        // If this was called during a load, try to load the next item.
        if (autoLoadOnItemsRemoved && itemsWereRemoved) {
            this._loadNext();
        }
    };

    // custom private methods
    p._getDuplicateLoadItems = function(items) {
        var current = Object.keys(this._loadItemsById);
        var duplicates = [];

        for (var index in items) {
            var itemId = items[index].id;
            if (createjs.indexOf(current, itemId) !== -1) {
                duplicates.push(itemId);
            }
        }

        return duplicates;
    };

    p._getItemsForReprioritization = function(priorityItems) {
        var items = [];

        for (var index in priorityItems) {
            var item = priorityItems[index];
            if (createjs.indexOf(this._duplicates, item.id) === -1) {
                items.push(item);
            }
        }

        return items;
    };


    // override private methods
    p._processFinishedLoad = function(item, loader) {
        this._numItemsLoaded++;

        // Since LoadQueue needs maintain order, we can't append scripts in the loader.
        // So we do it here instead. Or in _checkScriptLoadOrder();
        if (!this.maintainScriptOrder && item.type == createjs.Types.JAVASCRIPT) {
            var tag = loader.getTag();
            createjs.DomUtils.appendTagContent(tag);
        }

        this._updateProgress();
        this._sendFileComplete(item, loader);
        this._loadNext();
    };

    window.CustomLoadQueue = createjs.promote(CustomLoadQueue, "LoadQueue");
}());

/*
 * CustomJSONLoader
 */

(function() {
    "use strict";

    function CustomJSONLoader(loadItem) {
        this.JSONLoader_constructor(loadItem, true);
    };

    var p = createjs.extend(CustomJSONLoader, createjs.JSONLoader);
    var s = CustomJSONLoader;

    s.canLoadItem = function(item) {
        return item.type == createjs.Types.JSON;
    };

    p.cancel = function() {
        if (this._request) {
            this._request.cancel();
        }

        this.canceled = true;
        this.destroy();
    }

    window.CustomJSONLoader = createjs.promote(CustomJSONLoader, "JSONLoader");
}());

/*
 * CustomJSLoader
 */

(function() {
    "use strict";

    function CustomJSLoader(loadItem, _) {
        this.AbstractLoader_constructor(loadItem, window.scriptsPreferXHR, createjs.Types.JAVASCRIPT);

        // public properties
        this.resultFormatter = this._formatResult;

        // protected properties
        this._tagSrcAttribute = "src";
        this.setTag(createjs.Elements.script());
        if (!this._preferXHR) {
            this._tag.defer = window.deferScripts;
            this._tag.async = window.asyncScripts;
        }
    };

    var p = createjs.extend(CustomJSLoader, createjs.AbstractLoader);
    var s = CustomJSLoader;

    s.canLoadItem = function(item) {
        return item.type == createjs.Types.JAVASCRIPT;
    };

    p._formatResult = function(loader) {
        var tag = loader.getTag();
        if (this._preferXHR) {
            tag.text = loader.getResult(true);
        }
        return tag;
    };

    window.CustomJSLoader = createjs.promote(CustomJSLoader, "AbstractLoader");
}());

/*
 * DomUtils
 */

createjs.DomUtils.appendTagContent = function(tag) {
    if (window.injectScriptsToHead) {
        this.appendToHead(tag);
    } else {
        this.appendToBody(tag);
    }
}

/*
 * CustomTagRequest overrides
 */

createjs.TagRequest.prototype.load = function() {
    this._tag.onload = createjs.proxy(this._handleTagComplete, this);
    this._tag.onreadystatechange = createjs.proxy(this._handleReadyStateChange, this);
    this._tag.onerror = createjs.proxy(this._handleError, this);

    var evt = new createjs.Event("initialize");
    evt.loader = this._tag;

    this.dispatchEvent(evt);

    this._loadTimeout = setTimeout(createjs.proxy(this._handleTimeout, this), this._item.loadTimeout);

    this._tag[this._tagSrcAttribute] = this._item.src;

    // wdg:: Append the tag AFTER setting the src, or SVG loading on iOS will fail.
    if (this._tag.parentNode == null) {
        createjs.DomUtils.appendTagContent(this._tag);

        this._addedToDOM = true;
    }
};

createjs.TagRequest.prototype._clean = function() {
    this._tag.onload = null;
    this._tag.onreadystatechange = null;
    this._tag.onerror = null;
    clearTimeout(this._loadTimeout);
};